module.exports = __webpack_public_path__ + "static/media/coins.eeaa18d8.svg";